import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import BrandMark from "@/components/BrandMark";

/**
 * Landing page header — public, no auth state.
 * Layout: BBK logo (left) · Sign in link + "Browse catalog and pricing" pill CTA (right)
 */
export default function LandingHeader() {
  return (
    <header
      className="sticky top-0 z-40 bg-bone/85 backdrop-blur-md border-b border-borderSubtle"
      data-testid="landing-header"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <BrandMark variant="dark" size="sm" asLink={false} />

        <div className="flex items-center gap-3 sm:gap-4">
          <Link
            to="/enter"
            className="inline-flex items-center rounded-full border border-oxblood text-oxblood px-3 sm:px-4 py-1.5 sm:py-2 text-[11px] sm:text-[12px] uppercase tracking-[0.22em] font-semibold hover:bg-oxblood hover:text-bone transition-colors"
            data-testid="landing-signin-link"
          >
            Sign in
          </Link>
          <a
            href="#request-access"
            className="group inline-flex items-center gap-2 rounded-full bg-oxblood text-bone pl-3 pr-2 sm:pl-4 sm:pr-3 py-1.5 sm:py-2 text-[11px] sm:text-[12px] uppercase tracking-[0.2em] hover:bg-oxbloodDark transition-colors"
            data-testid="landing-browse-cta"
          >
            <span className="hidden sm:inline">Gain access to the research catalog</span>
            <span className="sm:hidden">Gain access</span>
            <span
              className="grid place-items-center w-5 h-5 rounded-full bg-bone/15 group-hover:bg-bone/25 transition-colors"
              aria-hidden
            >
              <ArrowRight size={11} strokeWidth={2} />
            </span>
          </a>
        </div>
      </div>
    </header>
  );
}
